import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentToken } from '../../../util';
import { Environment } from '../../../typings';

@Component({
    selector: 'app-job-preferences-success-page',
    templateUrl: './job-preferences-success-page.component.html',
    styleUrls: ['./job-preferences-success-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JobPreferencesSuccessPageComponent implements OnInit {
  aquentWebsite: string;
  matHost: string;
  constructor(@Inject(EnvironmentToken) private environment: Environment) {}

  ngOnInit(): void {
    this.aquentWebsite = this.environment.aquentWebsite;
    this.matHost = this.environment.matHost;
  }
}
